import styled from "styled-components";

export const Container = styled.li `

    > a {
        display: block;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        color: ${props => props.theme.colors.typography2.light} ;
        text-align: center;

        @media(min-width:480px) {
            font-size: 1.5rem;
            line-height: 29.8px;
        }

        @media(min-width:768px) {
            font-size: 0.875rem;
            padding: 0 24px;
            line-height: 15px;
        }
    }

    .a__navlink--active {
        color: ${props => props.theme.colors.brand1.pure};
        border-bottom: 3px solid ${props => props.theme.colors.brand1.pure};

        @media(min-width:768px) {
            border-bottom: 2px solid ${props => props.theme.colors.brand1.pure};
        }
    }
 
`